import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { Profile } from '../models/profile';

export const RefreshProfile = createAsyncThunk(
    'profilesData/refreshProfile',
    async (id: string, { getState }: any) => {
        const axios = getState().core.axios;
        try {
            const response = await axios.get(`api/Profiles/${id}`);
            return response.data as Profile;
        } catch (error) {
            createNotification(
                'Something went wrong, could not refresh profile data. Please try again.',
                'error'
            );
            throw error;
        }
    }
);
